import * as React from "react";

function SvgMouseStats(props, ref) {
  return (
    <svg
      id="MouseStats_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 33.5 27.3"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="currentColor"
        d="M11.8 13.1c-.5 0-.9-.4-.9-.9V2.6c0-.5.4-.9.9-.9s.9.4.9.9v9.5c.1.6-.3 1-.9 1zM19.6 13.1c-.5 0-.9-.4-.9-.9V6c0-.5.4-.9.9-.9s.9.4.9.9v6.2c0 .5-.4.9-.9.9zM17 13.1c-.5 0-.9-.4-.9-.9V8.7c0-.5.4-.9.9-.9s.9.4.9.9v3.4c.1.6-.3 1-.9 1zM14.4 13.1c-.5 0-.9-.4-.9-.9V6.7c0-.5.4-.9.9-.9s.9.4.9.9v5.5c.1.5-.3.9-.9.9zM9.2 13.1c-.5 0-.9-.4-.9-.9V6.1c0-.5.4-.9.9-.9s.9.4.9.9v6.1c.1.5-.4.9-.9.9zM23 19.6c-.9-.4-2.7-1.2-3.7-1.7.7-1 1.8-2.5 2.1-2.9.4-.6-.2-.9-.9-.9H9c-.4 0-.8 0-.9.3-.2.3-.2.5.4 1.1.6.6 6.7 6.9 7.4 7.6.6.7 1.1.5 1.3-.1.2-.5.6-2.4.8-3 .9.4 3.6 1.7 4.4 2.1 1 .4 1.6.2 1.9-.5.3-.7 0-1.4-1.3-2z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMouseStats);
